<template>
  <div class="container grid-container grid-container--4-8">
    <select-autocomplete
      class="col1"
      placeholder="Ej: 11"
      label="Código de área"
      maxlength="4"
      v-model="value.area"
      :required="required"
      :items="codigosAreaPopulares"
      :validationError="validationError"
      @input="onInput"
      @click="trackClick('codigoAreaCelular')"
    />
    <input-tip class="col2" description="Ingresá el número sin el 15">
      <number-input
        placeholder="Ej: 43464800"
        label="Número"
        maxlength="8"
        v-model="value.numero"
        :required="required"
        @click="trackClick('numeroCelular')"
      />
    </input-tip>
  </div>
</template>

<script>
import { codigosAreaPopulares } from "../../../../config/constants";
import NumberInput from "@/components/core/NumberInput";
import InputTip from "@/components/core/custom/InputTip";
import SelectAutocomplete from "@/components/core/custom/SelectAutocomplete";
import * as ACTIONS from "@/config/constants/action-types";

export default {
  name: "PhoneNumber",
  components: { NumberInput, InputTip, SelectAutocomplete },
  props: {
    label: String,
    value: Object
  },
  data() {
    return {
      validationError: null,
      checked: false
    };
  },
  methods: {
    onInput() {
      if (this.checked) {
        this.isValid(this.value.area);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValid(this.value.area);
    },
    isValid(val) {
      // El código de área debe ser numérico
      // El método sólo valida el código de área ya que el número se valida solo
      if (!isNaN(parseFloat(val)) && isFinite(val)) {
        // El valor es numérico
        this.validationError = null;
        return true;
      }
      this.validationError = "El código de área no es válido";
      return false;
    },
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(ACTIONS.DO_CLICK_TRACKING, el);
    }
  },
  computed: {
    codigosAreaPopulares() {
      return codigosAreaPopulares;
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .container div.col1 {
    margin-bottom: 24px;
  }
}
</style>
